module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-wedding-movie-24b804b80bdac3d5fee1c7972c761878.webp";